// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Taetigkeitsbericht } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteTaetigkeitsbericht(): (
  taetigkeitsberichtId: string
) => Promise<Taetigkeitsbericht> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId) =>
      (await getAPI()).taetigkeitsberichte.deleteTaetigkeitsbericht({
        taetigkeitsberichtId,
      }),
    [getAPI]
  );
}
